import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { AuthProvider } from "./components/AuthContext";
import Hero from "./components/Hero";
import ContactUs from "./components/ContactUs";
import Signup from "./components/Signup";
import Login from "./components/Login";
import FurbabiesHome from "./components/FurbabiesHome";
import PetNutrition from "./components/PetNutrition";
import PetHealth from "./components/PetHealth";
import Services from "./components/Services";
import About from "./components/AboutUs";
import ResetPassword from "./components/ResetPassword";
import ForgotPassword from "./components/ForgotPassword";
import SignupSuccess from "./components/SignupSuccess";
import SignupCancel from "./components/Signupcancel ";
import Account from "./components/Account";
import ProtectedRoute from "./components/ProtectedRoute";
import SubscriptionProtectedRoute from "./components/SubscriptionProtectedRoute";
import Blog from "./components/Blog";
import BlogPost from "./components/BlogPost";
import Newsletter from "./components/Newsletter";
import FurNews from "./components/FurNews";
import TermsAndConditions from "./components/Termsandconditions";
import PrivacyPolicy from "./components/Privacypolicy";
import CookiePolicy from "./components/Cookiepolicy";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const App = () => {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Elements stripe={stripePromise}>
          <Router>
            <Routes>
              <Route path="/" element={<Hero />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/login" element={<Login />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/newsletter" element={<Newsletter />} />
              <Route path="/furnews" element={<FurNews />} />
              <Route path="/resetpassword" element={<ResetPassword />} />
              <Route path="/forgotpassword" element={<ForgotPassword />} />
              <Route path="/signup-success" element={<SignupSuccess />} />
              <Route path="/signup-cancel" element={<SignupCancel />} />
              <Route path="/terms" element={<TermsAndConditions />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/cookie-policy" element={<CookiePolicy />} />
              <Route
                path="/furhome"
                element={<ProtectedRoute element={<FurbabiesHome />} />}
              />
              <Route
                path="/account"
                element={<ProtectedRoute element={<Account />} />}
              />
              <Route
                path="/pet-health"
                element={<SubscriptionProtectedRoute element={<PetHealth />} />}
              />
              <Route
                path="/pet-nutrition"
                element={
                  <SubscriptionProtectedRoute element={<PetNutrition />} />
                }
              />
            </Routes>
          </Router>
        </Elements>
      </AuthProvider>
    </HelmetProvider>
  );
};

export default App;
